<button
  pButton
  pRipple
  type="button"
  [label]="label"
  [loading]="loading"
  [disabled]="disabled"
  icon="pi pi-check"
  class="p-button-raised p-button-primary ml-3 mt-4"
></button>
